var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('img',{attrs:{"src":require("../assets/service/service.png"),"alt":""}}),_c('span',[_vm._v("长按二维码识别添加售后客服")]),_c('p',[_vm._v("客服坐席时间: 早上9点 - 夜间10点")]),_c('p',[_vm._v("客服热线: 400 005 9926")])])
}]

export { render, staticRenderFns }